import { render, staticRenderFns } from "./LogoAnimation.vue?vue&type=template&id=99b8e4d2&scoped=true&"
import script from "./LogoAnimation.vue?vue&type=script&lang=js&"
export * from "./LogoAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LogoAnimation.vue?vue&type=style&index=0&id=99b8e4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b8e4d2",
  null
  
)

export default component.exports